import  Http from '@/services';
import { Token, Storage, Cookie } from '@/utils';

const defaultAccessUser = {
    first_name: 'Jemuel',
    last_name: 'Acuna',
    photo: '',
    user:
    {
        username: 'jac001',
        user_type:
        {
            id: 1,
            name: 'Administrator'
        },
    },
}

export const auth = {

    namespaced: true,

    state:
    {
        accessToken: null,
        refreshToken: null,
        accessUser: {
            ...defaultAccessUser
        },
        isActive: false,

        signinLoading: false,
        signoutLoading: false,
        processLoading: false,
        updateLoading: false,
        userLoading: false,

        showSidebar: false,
    },

    mutations:
    {
        setTokens: (state, { accessToken, refreshToken }) =>
        {
            state.isActive = true;
            state.accessToken = accessToken;
            state.refreshToken = refreshToken;
        },

        setUser: (state, data) =>
        {
            state.accessUser = data;

            state.showSidebar = true;
        },

        setLoading: (state, { action, boolean }) =>
        {
            state[`${action}Loading`] = boolean;
        },

        resetState: (state) =>
        {
            state.isActive = false;
            state.accessUser = {
                ...defaultAccessUser
            },
            state.accessToken = null;
            state.refreshToken = null;
            state.showSidebar = false;
        },
    },

    actions:
    {
        update: async ({ commit }, { url, form }) =>
        {
            commit('setLoading', { action: 'update', boolean: true });

            const response = await Http.put(url, form);

            commit('setLoading', { action: 'update', boolean: false });

            if (response.status === 200)
            {
                commit('setUser', response.data);

                Storage.set(process.env.VUE_APP_ACCOUNT_STORAGE, JSON.stringify(response.data));
            }

            return response;
        },

        updatePassword: async ({ commit }, { url, form }) =>
        {
            commit('setLoading', { action: 'update', boolean: true });

            const response = await Http.put(url, form);

            commit('setLoading', { action: 'update', boolean: false });

            return response;
        },

        signin: async ({ commit, dispatch }, { form }) =>
        {
            commit('setLoading', { action: 'signin', boolean: true });

            const response = await Http.post('/login', form);

            commit('setLoading', { action: 'signin', boolean: false });

            if (response.status === 200)
            {
                await Token.set(response.data);
                
                await dispatch('loadUser');
            }

            return response;
        },

        signout: async ({ commit }) =>
        {
            commit('setLoading', { action: 'signout', boolean: true });

            const response = await Http.get('/logout');

            commit('setLoading', { action: 'signout', boolean: false });

            if (response.status === 200)
            {
                commit('resetState');

                Token.destroy();
            }

            return response;
        },

        loadUser: async ({commit}) => 
		{
			commit('setLoading', { action: 'user', boolean: true });

			const response = await Http.get('/my-account');

			if (response.status === 200)
            {
                commit(
                    'setTokens',
                    {
                        accessToken: Cookie.get(process.env.VUE_APP_ACCESS_TOKEN),
                        refreshToken: Cookie.get(process.env.VUE_APP_REFRESH_TOKEN),
                    }
                );

                commit('setUser', response.data);
            }
			
			commit('setLoading', { action: 'user', boolean: false });
	
			return response;
		},

        forceSignout: ({ commit }) =>
        {
            Token.destroy();

            commit('resetState');
        },

        updateUser: async ({ commit }, user) =>
        {
            commit('setUser', user);
        },

        unset: ({ commit }) =>
        {
            commit('resetState');
        },
    },

    getters:
    {
        accessUser: state => state.accessUser,

        isActive: state => state.isActive,

        isLoading: state => action => state[`${action}Loading`],

        showSidebar: state => state.showSidebar,
    },
};
